var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEtominVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    enableBackground: "new 0 0 40 40",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M20,40C8.972,40,0,31.028,0,20C0,8.972,8.972,0,20,0c11.028,0,20,8.972,20,20C40,31.028,31.028,40,20,40z  M20,1.905C10.023,1.905,1.905,10.023,1.905,20S10.023,38.095,20,38.095S38.095,29.978,38.095,20S29.978,1.905,20,1.905z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "15.198,30 15.198,10 28.612,20  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtominVideo);
export default __webpack_public_path__ + "static/media/etomin-video.73bf6fd511664f6da6c576788490f2ff.svg";
export { ForwardRef as ReactComponent };